import { z } from 'zod'

import { PrivacyLevelEnum } from './common.ts'

export const CreatorInfoProviderCodeEnum = z.enum([
  'spam_risk_too_many_posts',
  'spam_risk_user_banned_from_posting',
  'reached_active_user_cap',
  'access_token_invalid',
  'scope_not_authorized',
  'rate_limit_exceeded'
])
export type CreatorInfoProviderCode = z.infer<typeof CreatorInfoProviderCodeEnum>

export const CreatorInfoLoadStatusEnum = z.enum(['loading', 'ready', 'error'])
export type CreatorInfoLoadStatus = z.infer<typeof CreatorInfoLoadStatusEnum>

export const TikTokCreatorInfoEnvelopeSchema = z.object({
  data: z.unknown().optional(),
  error: z.object({
    code: z.string(),
    message: z.string(),
    log_id: z.string().optional()
  })
})
export type TikTokCreatorInfoEnvelope = z.infer<typeof TikTokCreatorInfoEnvelopeSchema>

export const TikTokCreatorInfoDataSchema = z.object({
  creator_nickname: z.string().min(1),
  creator_username: z.string().nullable().optional(),
  privacy_level_options: z.array(PrivacyLevelEnum),
  comment_disabled: z.boolean(),
  duet_disabled: z.boolean(),
  stitch_disabled: z.boolean(),
  max_video_post_duration_sec: z.number().int().positive()
})
export type TikTokCreatorInfoData = z.infer<typeof TikTokCreatorInfoDataSchema>

export const CreatorInfoResponseSchema = z.object({
  creatorNickname: z.string().min(1),
  creatorUsername: z.string().nullable(),
  privacyLevelOptions: z.array(PrivacyLevelEnum),
  commentDisabled: z.boolean(),
  duetDisabled: z.boolean(),
  stitchDisabled: z.boolean(),
  maxVideoPostDurationSec: z.number().int().positive()
})
export type CreatorInfoResponse = z.infer<typeof CreatorInfoResponseSchema>

export const CreatorInfoStateSchema = z.discriminatedUnion('status', [
  z.object({ status: z.literal(CreatorInfoLoadStatusEnum.enum.loading) }),
  z.object({ status: z.literal(CreatorInfoLoadStatusEnum.enum.ready), value: CreatorInfoResponseSchema }),
  z.object({ status: z.literal(CreatorInfoLoadStatusEnum.enum.error), message: z.string().min(1) })
])
export type CreatorInfoState = z.infer<typeof CreatorInfoStateSchema>

export const CreatorInfoErrorResponseSchema = z.object({
  error: z.object({
    code: CreatorInfoProviderCodeEnum,
    message: z.string().min(1)
  })
})
export type CreatorInfoErrorResponse = z.infer<typeof CreatorInfoErrorResponseSchema>
